export default {
  name: "ReviewsHeaderBlock",
  props: {
    title: {
      type: String,
      required: true,
    },
    text: {
      type: String,
      required: false,
    },
    actions: {
      type: Boolean,
      required: false,
    },
  }
}
